export default __webpack_public_path__ + "static/media/TY21_SDCF_F8937_Common - Investors.2d52795a.pdf";